import { width } from "../../../CustomComponents/Card/CardStyles";
import DynamicCard from "../../../CustomComponents/DynamicCard";
import Loader from "../../../CustomComponents/Loader";
import IdologyLayout from "../../../Layout/IdologyLayout";

const IdologySuccess = () =>{
    return (
        <>
            <IdologyLayout>
                <div className='sm:px-[6%] md:py-10 sm:py-12 flex flex-wrap sm:flex-nowrap'>
                    <div className='lg:w-[278px] md:w-[290px] w-[185px] sm:mx-0 ml-[2.5rem]'>

                        <p className="text-white font-normal
        lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px] 
        sm:leading-[30px] leading-[31px]
         font-serif-pro lg:pb-14 md:pb-[50px] sm:pb-[2.6rem] pb-[2.6rem] mb-10"></p>
                    </div>
                    <div className='md:w-[150px] sm:w-[70px] w-[0px]'></div>
                    <div className="flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] animate__animated animate__fadeInRight">
                            <DynamicCard
                                header={false}
                                CardRadius={true}
                                cardWidth={width.allpolicies}
                                HeaderRadius={true}
                                isWhiteForSignup={true}
                                isDarkForKudzu={false}
                                HeaderContent={false}>
                                <div className="md:py-20 sm:py-12 py-12 sm:mx-0 mx-4">
                                    <div className="flex-col justify-center sm:mx-0 mx-4">
                                        <div className="w-full flex justify-center">
                                           <h2>Success</h2>
                                        </div>
                                    </div>
                                </div>
                            </DynamicCard>
                    </div>
                </div>


            </IdologyLayout>
            
            {/* {isLoading && <Loader />} */}
        </>
    );

}
export default IdologySuccess;